<template>
	<div class="aboutHeader">
		<div class="back" @click="handleBackClick">
			<img class="backIcon" src="../assets/images/back.png" alt="">
		</div>
		<span class="title">
			<slot></slot>
		</span>
		<img class="menuIcon" src="../assets/images/union_menu.png" alt="">
	</div>
</template>

<script>
	export default {
		name: 'AboutHeader',
		components: {

		},
		methods: {
			handleBackClick() {
				this.$router.go(-1)
			}
		},
	}
</script>

<style scoped>
	.aboutHeader{
		width: 100%;
		height: 1rem;
		padding: 0 .25rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #D60000;
		color: #fff;
		box-sizing: border-box;
	}
	.aboutHeader .back{
		width: .6rem;
		height: .6rem;
		text-align: center;
        line-height: .6rem;
        display: flex;
        align-items: center;
    }
    .aboutHeader .title{
        font-size: .32rem;
    }
	.aboutHeader .backIcon{
		width: .2rem;
	}
	.aboutHeader .menuIcon{
		width: .375rem;
	}
</style>